/* eslint-disable import/prefer-default-export */
const generateFilterParams = (filters) => {
  const ret = {};
  const filterParameter = { ...filters };

  if (filterParameter.states != null && filterParameter.states.length > 0) {
    filterParameter.states = filterParameter.states.join(',');
  }

  if (filterParameter.lender != null && filterParameter.lender.length > 0) {
    filterParameter.lender = filterParameter.lender.join(',');
  }

  if (filterParameter.financeCompanies != null && filterParameter.financeCompanies.length > 0) {
    filterParameter.financeCompanies = filterParameter.financeCompanies.join(',');
  }

  const ary = Object.keys(filterParameter).map((key) => ({
    name: key,
    value: filterParameter[key],
  }));

  ary.filter((i) => i.value != null && i.value !== '').forEach((i) => { ret[`filters[${i.name}]`] = i.value; });

  return ret;
};

const getStatus = (submission, st) => {
  if (submission.status === 'Reviewed') {
    if (st.status === 'Approved' && new Date(st.expiresAt) < new Date()) {
      return 'Expired';
    }
    return st.status;
  } else if (submission.status === 'PendingAssignment') {
    return 'Pending Assignment';
  }
  return submission.status;
};

const mapByState = (submission, fieldSelector, nullValue) => {
  const distFields = [...new Set(submission.states.map(fieldSelector))];
  const groups = distFields.sort().map((f) => ({
    value: f || nullValue,
    states: submission.states
      .filter((st) => fieldSelector(st) === f)
      .map((st) => st.state)
      .join(', '),
  }));

  return groups.length === 1
    ? groups[0].value
    : groups.map((gr) => (gr.value ? `${gr.value}: ${gr.states}` : '')).join('\n');
};

const getDefaultPagination = (sortBy) => ({
  page: 1,
  itemsPerPage: 10,
  sortBy: sortBy ? [sortBy] : [],
  sortDesc: [true],
  groupBy: [],
  groupDesc: [],
  mustSort: false,
  multiSort: false,
});

export {
  generateFilterParams,
  getStatus,
  mapByState,
  getDefaultPagination,
};
